import { render, staticRenderFns } from "./LogReportView.vue?vue&type=template&id=56c59866&"
import script from "./LogReportView.vue?vue&type=script&lang=js&"
export * from "./LogReportView.vue?vue&type=script&lang=js&"
import style0 from "./LogReportView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports